<template>
  <div class="">
    <note-templates> </note-templates>
  </div>
</template>

<script>
import NoteTemplates from "@/components/profile/note-templates/index.vue";

import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    NoteTemplates,
  },
  created() {
    this.notifyQueue({
      text: "Configurazione",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Template Note",
      path: "note_templates.index",
      level: 2,
    });
  },
};
</script>
